import { Flex, Spin } from 'antd'
import { FlexProps, SpinProps } from 'antd/lib'
import { FC } from 'react'
import styled from 'styled-components'

const SpinContainer = styled(Flex)`
  height: 100vh;
  justify-content: center;
  align-items: center;
`

interface LoadingSpinnerProps {
  containerProps?: Partial<FlexProps>
  spinProps?: Partial<SpinProps>
}

const LoadingSpinner: FC<LoadingSpinnerProps> = ({ containerProps, spinProps }) => (
  <SpinContainer {...containerProps}>
    <Spin {...spinProps} />
  </SpinContainer>
)

export default LoadingSpinner
